import {
  useLearnConteudoMinistradoService
} from '../../../../../../services/learn/learn-conteudo-ministrado.service';
import { useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  useNotificationService
} from '../../../../../../services/notification.service';
import { IconType } from 'antd/lib/notification/interface';
import { useTranslation } from 'react-i18next';

interface CheckConteudoExistsOptions {
  enableNavigation?: boolean;
}

export default function useConteudoAlreadyRegistered() {
  const { id } = useParams();
  const { findConteudoAlreadyRegistered } = useLearnConteudoMinistradoService();
  const location = useLocation();
  const navigate = useNavigate();
  const notificationService = useNotificationService();
  const { t } = useTranslation(['gestao_de_aulas']);

  const notifyAndNavigate = (message: string, type: IconType, path: string) => {
    notificationService({ type, message });
    navigate(path);
  };

  const navigateToNextStep = () =>
    notifyAndNavigate(
       t('gestao_de_aulas:contentAlreadyRegistered'),
      'success',
      `/turmas/professor/lancamento-aula/create/step-1/${id}`
    );

  const checkIfConteudoExists = useCallback(async (
    { enableNavigation = true }: CheckConteudoExistsOptions = {}
  ) => {
    if (!id) return;

    const { data } = await findConteudoAlreadyRegistered(Number(id));

    if (enableNavigation && data && location.pathname.includes('step-1'))
      return navigateToNextStep();

    return Boolean(data);
  }, [findConteudoAlreadyRegistered, id, location.pathname, navigate]);

  return {
    checkIfConteudoExists
  };
};
